import type { Source } from './types';

export const sources: Source[] = [
  {
    id: 'mcd-10k-2024',
    title: "McDonald's Corporation Form 10-K, fiscal 2024",
    publisher: 'U.S. Securities and Exchange Commission',
    year: '2025',
    url: 'https://www.sec.gov/ix?doc=/Archives/edgar/data/63908/000006390825000013/mcd-20241231.htm',
    note: '加盟收入包含租金与权利金等，财报未单独拆分“地产收入”。',
  },
  {
    id: 'mcd-history',
    title: "McDonald's: Our History",
    publisher: "McDonald's Corporation",
    year: '2024',
    url: 'https://www.mcdonalds.com/us/en-us/about-us/our-history.html',
  },
  {
    id: 'tsmc-4q24',
    title: 'TSMC Reports Fourth Quarter EPS of NT$14.45',
    publisher: 'TSMC',
    year: '2025',
    url: 'https://pr.tsmc.com/english/news/3201',
    note: '2024 年第四季先进制程（7 纳米及以下）占晶圆收入 74%。',
  },
  {
    id: 'tsmc-ar-2024',
    title: 'TSMC 2024 Annual Report',
    publisher: 'TSMC',
    year: '2025',
    url: 'https://investor.tsmc.com/english/annual-reports',
    note: '用于核对纯晶圆代工模式、资本开支与产能分布。',
  },
  {
    id: 'amazon-ar-2024',
    title: 'Amazon 2024 Annual Report and Form 10-K',
    publisher: 'Amazon.com, Inc.',
    year: '2025',
    url: 'https://ir.aboutamazon.com/annual-reports-proxies-and-shareholder-letters/default.aspx',
    note: '2024 年净销售额约 6,380 亿美元；AWS 收入约 1,076 亿美元。',
  },
  {
    id: 'ftc-amazon-2023',
    title: 'FTC Sues Amazon for Illegally Maintaining Monopoly Power',
    publisher: 'U.S. Federal Trade Commission',
    year: '2023',
    url: 'https://www.ftc.gov/news-events/news/press-releases/2023/09/ftc-sues-amazon-illegally-maintaining-monopoly-power',
    note: '监管机构的主张，不等同于法院已经认定的全部事实。',
  },
  {
    id: 'nokia-annual-reports',
    title: 'Nokia Annual Reports and Filings',
    publisher: 'Nokia Corporation',
    year: '2007–2013',
    url: 'https://www.nokia.com/about-us/investors/reports-and-filings/annual-reports/',
    note: '用于核对 2007 年前后的业务结构与手机出货变化。',
  },
  {
    id: 'microsoft-nokia-2013',
    title: 'Microsoft to acquire Nokia’s Devices & Services business',
    publisher: 'Microsoft',
    year: '2013',
    url: 'https://news.microsoft.com/2013/09/03/microsoft-to-acquire-nokias-devices-services-business/',
  },
  {
    id: 'reuters-wework-2023',
    title: 'WeWork files for bankruptcy protection',
    publisher: 'Reuters',
    year: '2023',
    url: 'https://www.reuters.com/legal/wework-files-bankruptcy-protection-2023-11-07/',
  },
  {
    id: 'wework-court',
    title: 'In re: WeWork Inc., Case No. 23-19865 (Bankr. D.N.J.)',
    publisher: 'U.S. Bankruptcy Court for the District of New Jersey',
    year: '2023',
    url: 'https://restructuring.ra.kroll.com/WeWork/',
    note: '破产重组信息与债务、租约规模以法院文件为准。',
  },
  {
    id: 'doj-ftx-sentencing',
    title: 'Samuel Bankman-Fried Sentenced To 25 Years In Prison',
    publisher: 'U.S. Attorney’s Office, Southern District of New York',
    year: '2024',
    url: 'https://www.justice.gov/usao-sdny/pr/samuel-bankman-fried-sentenced-25-years-prison',
  },
  {
    id: 'doj-ftx-charges',
    title: 'United States Attorney Announces Charges Against FTX Founder Samuel Bankman-Fried',
    publisher: 'U.S. Department of Justice',
    year: '2022',
    url: 'https://www.justice.gov/usao-sdny/pr/united-states-attorney-announces-charges-against-ftx-founder-samuel-bankman-fried',
    note: '起诉书中的指控；后续陪审团裁定与量刑见 sentencing release。',
  },
  {
    id: 'fcic-report',
    title: 'The Financial Crisis Inquiry Report',
    publisher: 'Financial Crisis Inquiry Commission',
    year: '2011',
    url: 'https://www.govinfo.gov/content/pkg/GPO-FCIC/pdf/GPO-FCIC.pdf',
    note: '对美国 2008 年金融危机的调查性叙述；不同学派对成因权重仍有争论。',
  },
  {
    id: 'fed-great-recession',
    title: 'The Great Recession',
    publisher: 'Federal Reserve History',
    year: '2013',
    url: 'https://www.federalreservehistory.org/essays/great-recession-of-200709',
  },
  {
    id: 'standard-oil-1911',
    title: 'Standard Oil Co. of New Jersey v. United States, 221 U.S. 1',
    publisher: 'U.S. Supreme Court / Justia',
    year: '1911',
    url: 'https://supreme.justia.com/cases/federal/us/221/1/',
  },
  {
    id: 'levinson-box',
    title: 'The Box: How the Shipping Container Made the World Smaller and the World Economy Bigger',
    publisher: 'Princeton University Press',
    year: '2006 / 2016',
    url: 'https://press.princeton.edu/books/paperback/9780691170817/the-box',
    note: '集装箱装卸成本的历史估算存在口径争议，书中数字按美国 1950 年代案例理解。',
  },
  {
    id: 'world-bank-logistics',
    title: 'Connecting to Compete: Trade Logistics in the Global Economy',
    publisher: 'World Bank',
    year: '2023',
    url: 'https://lpi.worldbank.org/',
    note: '用于理解物流基础设施与贸易成本，不用于推断单一项目的因果效果。',
  },
  {
    id: 'uksc-uber-2021',
    title: 'Uber BV and others v Aslam and others [2021] UKSC 5',
    publisher: 'UK Supreme Court',
    year: '2021',
    url: 'https://www.supremecourt.uk/cases/uksc-2019-0029',
    note: '英国法下的“worker”身份，不等同于所有法域的“employee”。',
  },
  {
    id: 'ca-prop22-2020',
    title: 'Proposition 22: App-Based Drivers as Contractors and Labor Policies Initiative',
    publisher: 'California Secretary of State',
    year: '2020',
    url: 'https://vig.cdn.sos.ca.gov/2020/general/pdf/topl-prop22.pdf',
  },
  {
    id: 'eu-platform-work-2024',
    title: 'Directive (EU) 2024/2831 on improving working conditions in platform work',
    publisher: 'Official Journal of the European Union',
    year: '2024',
    url: 'https://eur-lex.europa.eu/eli/dir/2024/2831/oj',
  },
  {
    id: 'copilot-arxiv',
    title: 'The Impact of AI on Developer Productivity: Evidence from GitHub Copilot',
    publisher: 'arXiv',
    year: '2023',
    url: 'https://arxiv.org/abs/2302.06590',
    note: '受控任务中完成时间缩短约 55%，不能外推为所有开发工作的平均提升。',
  },
  {
    id: 'metr-2025',
    title: 'Measuring the Impact of Early-2025 AI on Experienced Open-Source Developer Productivity',
    publisher: 'METR',
    year: '2025',
    url: 'https://metr.org/blog/2025-07-10-early-2025-ai-experienced-os-dev-study/',
    note: '熟悉自身代码库的资深开发者在特定任务上反而约慢 19%，与主观感受相反。',
  },
  {
    id: 'mixue-prospectus',
    title: 'Mixue Group Global Offering Prospectus',
    publisher: 'Hong Kong Exchanges and Clearing',
    year: '2025',
    url: 'https://www1.hkexnews.hk/listedco/listconews/sehk/2025/0303/11551173/sehk25021401285.pdf',
    note: '招股书披露加盟门店、向加盟商销售商品与设备等收入结构。',
  },
  {
    id: 'nobel-natural-experiments',
    title: 'Natural Experiments Help Answer Important Questions for Society',
    publisher: 'The Nobel Prize',
    year: '2021',
    url: 'https://www.nobelprize.org/prizes/economic-sciences/2021/popular-information/',
    note: '用于证据方法页：相关不等于因果，需要反事实与识别策略。',
  },
  {
    id: 'fed-great-inflation',
    title: 'The Great Inflation',
    publisher: 'Federal Reserve History',
    year: '2013',
    url: 'https://www.federalreservehistory.org/essays/great-inflation',
    note: '美国 1960s—1980s 通胀史；不同学派对成因权重存在争论。',
  },
  {
    id: 'bls-cpi',
    title: 'Consumer Price Index',
    publisher: 'U.S. Bureau of Labor Statistics',
    year: '2026',
    url: 'https://www.bls.gov/cpi/',
    note: '用于核对美国 CPI 的口径、基期与月度数据。',
  },
  {
    id: 'fred-cpi',
    title: 'Consumer Price Index for All Urban Consumers: All Items',
    publisher: 'Federal Reserve Bank of St. Louis / FRED',
    year: '2026',
    url: 'https://fred.stlouisfed.org/series/CPIAUCSL',
    note: '时间序列数据；同比与环比需自行计算，不能与不同国家口径直接比较。',
  },
  {
    id: 'opec-history',
    title: 'OPEC: Brief History',
    publisher: 'Organization of the Petroleum Exporting Countries',
    year: '2024',
    url: 'https://www.opec.org/opec_web/en/about_us/24.htm',
  },
  {
    id: 'eia-oil-prices',
    title: 'Oil and petroleum products explained: Prices and outlook',
    publisher: 'U.S. Energy Information Administration',
    year: '2025',
    url: 'https://www.eia.gov/energyexplained/oil-and-petroleum-products/prices-and-outlook.php',
    note: '用于理解原油价格、供需与地缘冲击；不用于预测未来价格。',
  },
  {
    id: 'fed-asian-crisis',
    title: 'Asian Financial Crisis',
    publisher: 'Federal Reserve History',
    year: '2013',
    url: 'https://www.federalreservehistory.org/essays/asian-financial-crisis',
    note: '1997—1998 亚洲金融危机的机制性回顾。',
  },
  {
    id: 'worldbank-east-asia',
    title: 'The East Asian Miracle: Economic Growth and Public Policy',
    publisher: 'World Bank',
    year: '1993',
    url: 'https://www.worldbank.org/en/research',
    note: '用于讨论产业政策与东亚增长的争论；观点和归因存在不同解释。',
  },
  {
    id: 'fda-hatch-waxman',
    title: 'Hatch-Waxman Act and Its Amendments',
    publisher: 'U.S. Food and Drug Administration',
    year: '2024',
    url: 'https://www.fda.gov/drugs/abbreviated-new-drug-application-anda/hatch-waxman-act-and-its-amendments',
    note: '美国法域；仿制药审批、专利链接与 exclusivity 的具体适用需回到法条与判例。',
  },
  {
    id: 'ftc-generic-drugs',
    title: 'Generic Drugs',
    publisher: 'U.S. Federal Trade Commission',
    year: '2024',
    url: 'https://www.ftc.gov/news-events/topics/competition-enforcement/generic-drugs',
    note: '竞争执法视角；具体案件结论以法院与执法机构文件为准。',
  },
  {
    id: 'nobel-transistor',
    title: 'The Nobel Prize in Physics 1956',
    publisher: 'The Nobel Prize',
    year: '1956',
    url: 'https://www.nobelprize.org/prizes/physics/1956/summary/',
  },
  {
    id: 'bell-labs-history',
    title: 'Bell Labs History',
    publisher: 'Nokia Bell Labs',
    year: '2024',
    url: 'https://www.bell-labs.com/about/history/',
    note: '机构史叙事；具体发明优先对照论文、专利与诺贝尔奖材料。',
  },
  {
    id: 'shenzhen-gov',
    title: 'Shenzhen: City Profile and Statistics',
    publisher: 'Shenzhen Municipal People’s Government',
    year: '2024',
    url: 'https://www.sz.gov.cn/en/',
    note: '用于城市与特区的基本数据；统计口径以官方公报为准。',
  },
  {
    id: 'worldbank-china-sez',
    title: 'China’s Special Economic Zones: Experience and Prospects',
    publisher: 'World Bank',
    year: '2015',
    url: 'https://www.worldbank.org/en/country/china/publication/chinas-special-economic-zones-experience-and-prospects',
    note: '世界银行对经济特区经验的评估；政策效果存在地区与时期差异。',
  },
  {
    id: 'aliresearch-taobao-village',
    title: 'Taobao Village Research Reports',
    publisher: 'AliResearch',
    year: '2023',
    url: 'http://www.aliresearch.com/en/',
    note: '“淘宝村”的定义与数量来自阿里研究院口径；属于平台研究，不等同于独立学术统计。',
  },
  {
    id: 'costco-annual-report',
    title: 'Costco Wholesale 2024 Annual Report',
    publisher: 'Costco Wholesale Corporation',
    year: '2024',
    url: 'https://investor.costco.com/financials/annual-reports/default.aspx',
    note: '会员费、毛利率与销售数据以财报口径为准。',
  },
];

export const sourceMap = new Map(sources.map((source) => [source.id, source]));

export function getSource(id: string): Source | undefined {
  return sourceMap.get(id);
}
